import { Preset } from '../types/compensation'

export const presets: Preset[] = [
  {
    id: 'snakker',
    name: 'Snakker preferred',
    tagline: 'Our recommended anchor — lean fixed, weighted to performance',
    fixedMonthly: 55_000,
    commissionShare: 0.7,
    recommended: true,
  },
  {
    id: 'security',
    name: 'Security',
    tagline: 'High guaranteed cash, modest upside',
    fixedMonthly: 80_000,
    commissionShare: 0.5,
  },
  {
    id: 'balanced',
    name: 'Balanced',
    tagline: 'Even split between upside and ownership',
    fixedMonthly: 65_000,
    commissionShare: 0.5,
  },
  {
    id: 'hunter',
    name: 'Hunter',
    tagline: 'Maximum commercial upside',
    fixedMonthly: 52_000,
    commissionShare: 0.8,
  },
  {
    id: 'owner',
    name: 'Owner',
    tagline: 'Long-term ownership weighted',
    fixedMonthly: 52_000,
    commissionShare: 0.3,
  },
]
